export const SKIP_SUPERVISOR = 'Skip Supervisor';
export const APPROVE = 'Approve';
export const APPROVE_MANUALLY = 'Approve Manually';
export const RETURN_TO_REQUESTOR = 'Return to Requestor';
export const REJECT = 'Reject';
export const ATTACHMENT_DEFAULT_PLACEHOLDER = 'Attach your documents by clicking Browse';

// Vendor Status Strings
export const RETURN_TO_SUPPLIER = 'Requestor Returned';
export const REQUESTOR_APPROVED = 'Requestor Approved';
export const REQUESTOR_REJECTED = 'Requestor Rejected';
export const SUPERVISOR_APPROVED = 'Supervisor Approved';
export const SUPERVISOR_REJECTED = 'Supervisor Rejected';
export const SUPERVISOR_RETURN_TO_REQUESTOR = 'Supervisor Returned';
export const ADMIN_APPROVED = 'Admin Approved';
export const ADMIN_REJECTED = 'Admin Rejected';
export const ADMIN_RETURN_TO_REQUESTOR = 'Admin Returned';
export const VENDOR_SUBMITTED = 'Vendor Submitted';
export const DRAFTED = 'In Draft';

// Payment methods
export const CPC = 'cpc';
export const BIP = 'bip';
export const ELECTRONIC = 'electronic';

// countries
export const USA = 'united states';

// Action Labels
export const EXPLAIN_REASON = 'Please explain the reason below';
export const ENTER_COMMENTS = 'Please enter the comments below';
export const REASON_VALIDATION_MESSAGE = 'Please enter the reason';
export const ENTER_SITE_ID_VENDOR_ID = 'Please enter the Vendor No/Site ID';

// Tax fields
export const NIF = 'nif';
export const ABN = 'abn';
export const BUSINESS_REG_CERT_NO = 'businessRegCertificateNo';
export const IS_MSME = 'isMsme';
export const PAN = 'panNo';
export const SERVICE_TAX = 'serviceTaxNo';
export const REGISTERED_STATE = 'registeredState';
export const REGISTRATION_NUMBER = 'registeredStateNo';
export const TIN = 'tin';
export const UEN = 'uen';